export interface OrderCreditLimitEntity {
  orderId: string;
  orderNo: string;
  refOrderNo: string;
  company: string;
  customerName: string;
  taxNo: string;
  totalPrice: string;
  createAt: string;
  status: string;
  isOverCredit: boolean;
  requestedOverCredit: string;
  percentOverCredit: string;
  creditStatus: string;
  soStatus: string;
  thisStatus: string;
}
export const OrderCreditLimitEntity_INIT: OrderCreditLimitEntity = {
  orderId: "",
  orderNo: "",
  refOrderNo: "",
  company: "",
  customerName: "",
  taxNo: "",
  totalPrice: "",
  createAt: "",
  status: "",
  isOverCredit: false,
  requestedOverCredit: "",
  percentOverCredit: "",
  creditStatus: "",
  soStatus: "",
  thisStatus: "",
};
export interface AllOrderCreditLimitEntity {
  countOrder: number;
  countPending: number;
  count: number;
  lastUpdate: string;
  data: OrderCreditLimitEntity[];
}
export const AllOrderCreditLimitEntity_INIT: AllOrderCreditLimitEntity = {
  countOrder: 0,
  countPending: 0,
  count: 0,
  lastUpdate: "",
  data: [OrderCreditLimitEntity_INIT],
};
export interface detailEntity {
  userStaffId: string;
  userStaffName: string;
  action: string;
  type: string;
  role: string | null;
  sequence: number;
  sequenceRequired: number;
  updateAt: string;
  reason: string | null;
}
export interface allSequenceEntity {
  sequence: number;
  role: string | null;
  sequenceRequired: number;
  detail: detailEntity[];
}
export interface orderCreditEntity {
  orderId: string;
  orderNo: string;
  orderRefNo: null;
  customerName: string;
  company: string;
  status: string;
  totalPrice: string;
  createAt: string;
  updateAt: string;
  expectedCreditApprover: number;
  actualCreditApprover: number;
  expectedSoApprover: number;
  actualSoApprover: number;
  isOverCredit: boolean;
}
export interface creditApproversEntity {
  countSequence: number;
  allSequence: allSequenceEntity[];
}
export interface soApproversEntity {
  countSequence: number;
  allSequence: allSequenceEntity[];
}
